export default __webpack_public_path__ + "assets/images/19942b3f97982b24d6dc186915d0ad23.svg";